import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Cabecera, CatClaveProdServoce, CFDI, CatClaveUnidad, CatFormaPago, CatImpuestos2, CatMetodoPago, CatMoneda, codPostal, EmisoresIntegraciones, figTrans, listSeries, partTrans, regFiscal, usoCFDI, usoPAIS } from '../models';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class FacturacionService {
  private headerApk: HttpHeaders;
  public eventSendCabecera: EventEmitter<Cabecera> = new EventEmitter<Cabecera>();

  constructor(
    private http:HttpClient
  ) {
    this.headerApk = new HttpHeaders({
      'Content-Type': 'application/json',
      'Api-Key': environment.apks
    });
  }

  public catalogoImpuestos(): Observable<CatImpuestos2[]> {
    return this.http.get<CatImpuestos2[]>(`${environment.url_catalogos}/api/v3/list/impuesto/`, { headers: this.headerApk, });
  }
  
  public catalogoMoneda(): Observable<CatMoneda[]> {
    return this.http.get<CatMoneda[]>(`${environment.url_catalogos}/api/v3/catalogos_monedas`, { headers: this.headerApk });
  }


  public figuratransporte(): Observable<figTrans[]> {
    return this.http.get<figTrans[]>(`${environment.url_catalogos}/Catalogos/figura_transporte`, { headers: this.headerApk });
  }

  public parteTrans(): Observable<partTrans[]> {
    return this.http.get<partTrans[]>(`${environment.url_catalogos}/Catalogos/parte_transporte`, { headers: this.headerApk });

  }

  public cpPostal(cp: string): Observable<codPostal[]> {
    return this.http.get<codPostal[]>(`${environment.url_catalogos}/Catalogos/codigo_postal/${cp}`, { headers: this.headerApk });
  }

  public claveProductodes(cp: string): Observable<CatClaveProdServoce[]> {
    return this.http.get<CatClaveProdServoce[]>(`${environment.url_catalogos}/api/v3/clave_producto_servicio/descripcion/${cp}`, { headers: this.headerApk });
  }

  public catalogoClaveUnidadM(cp: string): Observable<CatClaveUnidad[]> {
    return this.http.get<CatClaveUnidad[]>(`${environment.url_catalogos}/api/v3/clave_unidad/descripcion/${cp}`, { headers: this.headerApk });
  }

  public emisionSeries(centroConsumoId: number, tipoCfdi: string): Observable<listSeries> {
    return this.http.get<listSeries>(
      `${environment.url_emisores}/api/v1/integraciones/series_consulta/${centroConsumoId}/${tipoCfdi}`,
      { headers: this.headerApk });
  }

  public generarCFDI(body: CFDI): Observable<any> {
    return this.http.post<any>(`${environment.url_orquestador}/api/v1/next/cfdis`, JSON.stringify(body), { headers: this.headerApk });
  }

  public emisionIntegracion(rfc: string): Observable<EmisoresIntegraciones> {
    return this.http.get<EmisoresIntegraciones>(`${environment.url_emisores}/stage/api/v1/emisor/${rfc}`, { headers: this.headerApk });
  }

  public usoPais(): Observable<usoPAIS[]> {
    return this.http.get<usoPAIS[]>(`${environment.url_catalogos}/api/v3/paises/list/`, { headers: this.headerApk });
  }

  public usoCfdi(): Observable<usoCFDI[]> {
    return this.http.get<usoCFDI[]>(`${environment.url_catalogos}/api/v3/list/uso_cfdi/`, { headers: this.headerApk });
  }

  public regimenFiscal(): Observable<regFiscal[]> {
    return this.http.get<regFiscal[]>(`${environment.url_catalogos}/api/v3/list/regimen_fiscal/`, { headers: this.headerApk });
  }

  public catalogoFormaPago(): Observable<CatFormaPago[]> {
    return this.http.get<CatFormaPago[]>(`${environment.url_catalogos}/api/v3/clave_forma_pago/list/`, { headers: this.headerApk });
  }

  public catalogoMetodoPago(): Observable<CatMetodoPago[]> {
    return this.http.get<CatMetodoPago[]>(`${environment.url_catalogos}/api/v3/list/metodo_de_pago/`, { headers: this.headerApk });
  }
 
  public facturar(body:CFDI) : Observable<any> {
    return this.http.post<any>(`${environment.url_orquestador}/api/v1/next/cfdis`,JSON.stringify(body),{ headers: this.headerApk });
  }

  public reenviarFactura(body: { folio_fiscal: string, email: string[] }): Observable<any> {
    return this.http.post<any>(`${environment.email}/api/v1/email`, JSON.stringify(body), { headers: this.headerApk });
  }
}